import { useQuery } from '@apollo/client'
import { USER_ADDON_KINDS_QUERY } from '../queries'

/** The three separately stored things an approver calls "a tillegg". */
export type AddonKind = 'time' | 'fixed' | 'override'

export type EnabledAddonKinds = Record<AddonKind, boolean>

/**
 * Which addon kinds the user's salary work time offers. A kind that is turned
 * off there is hidden everywhere it would otherwise be listed or added.
 *
 * Every kind counts as enabled until the work time has been read, so the lists
 * keep loading in parallel with this query instead of waiting a round trip for
 * it — and a user with no salary work time at all keeps seeing all three.
 */
export function useEnabledAddonKinds(
  userId: string | undefined,
  options: { enabled?: boolean } = {}
): EnabledAddonKinds {
  const { data } = useQuery(USER_ADDON_KINDS_QUERY, {
    variables: { id: userId ?? '' },
    skip: !userId || options.enabled === false,
  })

  const salaryWorkTime = data?.user?.salaryWorkTime

  return {
    time: salaryWorkTime?.useTimeAddons ?? true,
    fixed: salaryWorkTime?.useFixedAddons ?? true,
    override: salaryWorkTime?.useTimeOverrides ?? true,
  }
}
